module.exports = __webpack_public_path__ + "static/media/12.a7672393.png";